import { lighten } from 'polished'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import colors from '../../lib/colors'
import { IColorTheme } from '../../types/itemTypes'
import { ICategoryResponse } from '../../types/organisation'

const Title = styled.div`
  background-color: ${(props): string => props.theme.colourHighlight};
  color: ${(props): string => props.theme.colourTextOnHighlight};
  min-height: 42px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 7px;
  box-sizing: border-box;
  transition-property: background-color;
  transition-duration: 0.2s;
`
const Image = styled.div`
  background: url(${(props): string => props.theme});
  background-size: cover;
  background-position: center;
  transition-property: filter;
  transition-duration: 0.2s;
  box-shadow: 0px 2px 4px ${colors.shadow};
  position: relative;
  flex: 1;
`
const Styles = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(232px, 1fr));
  grid-gap: 20px;
  width: inherit;
  max-width: 1068px;
  margin: auto;
  padding: 25px;
  @media (max-width: 320px) {
    padding: 5px;
  }
  background-color: ${(props): string => props.theme.colourPageBackground};
  & :hover > ${Title} {
    background-color: ${(props): string => lighten(0.05, props.theme.colourHighlight)};
    color: ${(props): string => lighten(0.05, props.theme.colourTextOnHighlight)};
  }
`
const Category = styled.div`
  position: relative;
  min-width: 232px;
  height: 312px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
`

interface ICategoryGridProps {
  categories: ICategoryResponse[]
  setSelectedCategoryId: (categoryId: number) => void
  colorTheme?: Partial<IColorTheme>
}
export default function CategoryGrid(props: ICategoryGridProps): ReactElement {
  const { categories, setSelectedCategoryId, colorTheme } = props

  const render = categories.map((category) => {
    if (category.parent === 0) {
      return (
        <Category
          key={category.id}
          onClick={(): void => setSelectedCategoryId(category.id)}
        >
          <Image theme={category.imageUrl} />
          <Title theme={colorTheme}>{category.title}</Title>
        </Category>
      )
    }
    return null
  })

  return <Styles theme={colorTheme}>{render}</Styles>
}
